import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';

class CharacterListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
      },
      characters: [],
    });
  }

  init = action(() => {
    this.characters = [];
    this.form.setInitialValues({});
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/characters',
        apiVersion: 'v3',
        query: {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          expand: 'academicPlan',
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.characters = this.fetch.data.docs;
          this.pagination.total = this.fetch.data.total;
        } else {
          this.characters = [];
          this.pagination.current = 1;
          this.pagination.total = 0;
        }
      });
  });

  handleChange = action((pagination) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.load();
  });

  handleFilter = action(() => {
    this.pagination = { ...this.pagination, current: 1 };
    this.load();
  });

  handleRemove = action((character) => {
    ConfirmationDialogService.show(
      'Delete Character',
      `You are about to delete the Character "${character.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/characters/${character.id}`,
            method: 'delete',
            apiVersion: 'v3',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(`Character "${character.name}" deleted successfully.`, 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const characterListService = new CharacterListService();

export default characterListService;
